import React from 'react';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';
import { ChangedToastMessageTitle, ChangedToastMessageContent } from './ChangedToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showChangedToastMessage = ({ title, content }) =>
  newToastMessage({
    iconId: '#icon-check-circle',
    // eslint-disable-next-line react/jsx-filename-extension
    ...(title && { title: <ChangedToastMessageTitle title={title} /> }),
    ...(content && { content: <ChangedToastMessageContent content={content} /> }),
    className: 'els-toast-message changed-toast-message',
    closeBtn: true,
  });
